import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import * as expenseActions from "../../actions/expenseActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ExpenseForm from "./ExpenseForm";

const ExpenseAddPage = ({ auth, history }) => {
  const customers = useSelector((state) => state.reducers.customers);
  const users = useSelector((state) => state.reducers.users);
  const codes = useSelector((state) => state.reducers.codes);

  const dispatch = useDispatch();

  const handleCancel = () => {
    history.push("/app/expenses");
  };

  const handleAdd = async (expense) => {
    dispatch(expenseActions.createExpense(expense));
    history.push("/app/expenses");
  };

  return (
    <React.Fragment>
      <HeaderWrapper breadcrumbs={[{ label: "Add Customer Expense Report" }]} />
      <div className="content-wrapper">
        <ExpenseForm
          adding
          editing
          expense={{}}
          customers={customers}
          codes={codes}
          users={users}
          onCancel={handleCancel}
          auth={auth}
          onAdd={handleAdd}
          hideReceiptDelete={false}
        />
      </div>
    </React.Fragment>
  );
};

ExpenseAddPage.propTypes = {
  history: PropTypes.object,
  auth: PropTypes.object
};

export default ExpenseAddPage;
